import { useId } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';

interface BrandLogoProps {
  compact?: boolean;
  className?: string;
}

export function BrandLogo({ compact = false, className = '' }: BrandLogoProps) {
  const { t } = useTranslation();
  const brandName = t('common.brandName');
  // Several logos can render at once; a shared gradient id resolves to the
  // first match, which paints nothing when that instance is display:none.
  const gradientId = `brand-gradient-${useId().replace(/:/g, '')}`;

  return (
    <span className={`brand-logo${compact ? ' brand-logo--compact' : ''} ${className}`.trim()}>
      <svg
        className="brand-logo__mark"
        viewBox="0 0 32 32"
        role={compact ? 'img' : undefined}
        aria-label={compact ? brandName : undefined}
        aria-hidden={compact ? undefined : true}
      >
        <path d="M21.07 10c.42-.02.53.18.64.54-.08.27-.13.34-.36.5.01.42 0 .87.07 1.28.1.02.22.04.31.07.13.04.2.29.3.31.8.17 1.58-.06 2.24.56.53.5.64 1.18.67 1.88l.04.01c.98.22.92 2.3.25 2.79-.05.04-.35.15-.36.19-.21.77-.77 1.39-1.6 1.45-.63.04-1.28.06-1.92.07-.64.01-2.25.03-2.77-.21-.59-.27-.8-.77-1.01-1.34-.84-.12-.96-1.21-.85-1.89.09-.55.28-.85.77-1.08.1-.81.19-1.61.95-2.07.62-.37 1.3-.22 1.97-.36.02-.02.03-.03.04-.06.1-.26.25-.26.49-.3.03-.43.05-.86.06-1.29-.44-.33-.46-.8.07-1.06Z" fill="#027BFA" />
        <path d="M9.71 12.06a4.11 4.11 0 1 1 .24 8.22 4.11 4.11 0 0 1-.24-8.22Z" fill="#00D74C" />
        <path d="M17.23 20.53c-.57-.52-.99-.76-1.79-.78-.79.05-1.2.45-1.82 1.06l-1.83 1.76c-.63.6-1.36 1.3-2.26.98-.3-.11-.52-.19-.75-.42-.39-.4-.77-.83-1.14-1.26l-3.26-3.68c-.04-.05-.11-.12-.19-.21-.35-.4-.96-1.1-1.15-1.24a1.49 1.49 0 0 0-1.46-.27c-.43.28-.58.7-.55 1.13.02.33.69 1.49 1.06 2.13l2.09 3.74 1.61 2.88c.07.11.13.24.21.38.2.36.42.76.6 1.05.25.38.55.72.89 1.01.83.7 1.88.97 2.95.86 1.82-.17 2.58-1.3 3.43-2.69l1.05-1.72c.05-.07.09-.15.14-.23.29-.5.63-1.08 1.22-1.13.56.06.88.6 1.15 1.07l1.16 1.86c.28.45.56.9.92 1.29 1.41 1.54 4.01 1.52 5.49.11.59-.56.96-1.27 1.33-1.99l1.93-3.56c.57-1.02 1.13-2.04 1.7-3.06.48-.97-.23-2.17-1.33-2.16-.26-.01-.71.1-.91.28-.33.32-.7.75-1.03 1.14l-3 3.47-1.04 1.22c-.66.78-1.27 1.5-2.45.95-.2-.09-.42-.31-.61-.49l-1.51-1.38Z" fill={`url(#${gradientId})`} />
        <defs><linearGradient id={gradientId} x1="28" y1="24" x2="3" y2="24" gradientUnits="userSpaceOnUse"><stop stopColor="#007AFA" /><stop offset=".62" stopColor="#007AFA" /><stop offset=".62" stopColor="#00D74C" /><stop offset="1" stopColor="#00D74C" /></linearGradient></defs>
      </svg>
      {!compact && <span className="brand-logo__name">{brandName}</span>}
    </span>
  );
}
